// extracted by mini-css-extract-plugin
module.exports = {"main":"notFound_main__gfgIZ","logo":"notFound_logo__PPlZ0","termsLogo":"notFound_termsLogo__6flUk"};